/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import type { IAPI } from '../../../apiResponse';
import { createApiResponseSchema } from '../../../apiResponse';
import { adminSubscriptionSchema } from '../listSubscriptions/list-subscriptions-response';

export const grantManualSubscriptionResponseSchema = createApiResponseSchema(
  adminSubscriptionSchema,
) as z.ZodSchema<IAPI<z.infer<typeof adminSubscriptionSchema>>>;

export type IGrantManualSubscriptionResponse = z.infer<
  typeof grantManualSubscriptionResponseSchema
>;
